import React, { useState } from "react";
import {PhoneHQConfirmDialog} from "ch3-ui-lib";

interface DeleteConfirmDialogProps {
    /** Controlled open state. Omit to let the dialog manage its own state (trigger usage). */
    open?: boolean;
    /** Open state change handler */
    onOpenChange?: (open: boolean) => void;
    /** Element that opens the dialog (uncontrolled usage) */
    trigger?: React.ReactElement;
    /** Fired when the user confirms the deletion */
    onConfirm: () => void;
    /** Header text */
    title?: React.ReactNode;
    /** Body content describing the consequences */
    description?: React.ReactNode;
    /** Label for the destructive action */
    confirmLabel?: string;
}

const DeleteConfirmDialog = ({
    open,
    onOpenChange,
    trigger,
    onConfirm,
    title = "Are you sure to delete?",
    description = (
        <>
            <p className="leading-5 mb-4">
                This action will permanently remove this contact and all associated data.
            </p>
            <p className="leading-5">This cannot be undone.</p>
        </>
    ),
    confirmLabel = "Yes, Delete",
}: DeleteConfirmDialogProps) => {
    const [internalOpen, setInternalOpen] = useState(false);
    const isControlled = open !== undefined;
    const isOpen = isControlled ? open : internalOpen;

    const setOpen = (next: boolean) => {
        if (!isControlled) setInternalOpen(next);
        onOpenChange?.(next);
    };

    const handleConfirm = () => {
        onConfirm();
        setOpen(false);
    };

    return (
        <PhoneHQConfirmDialog
            open={isOpen}
            onOpenChange={setOpen}
            trigger={trigger}
            title={typeof title === "string" ? title : "Delete"}
            cancelLabel="Cancel"
            confirmLabel={confirmLabel}
            tone="danger"
            onConfirm={handleConfirm}
        >
            {description}
        </PhoneHQConfirmDialog>
    );
};

export default DeleteConfirmDialog;
